import { render, staticRenderFns } from "./DocumentTypeFiltering.vue?vue&type=template&id=f85880a4&scoped=true&"
import script from "./DocumentTypeFiltering.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85880a4",
  null
  
)

export default component.exports